<template>
	<vue-scroll>
		<div id="page-contacts" class="page-addtransaction scrollable only-y" v-show="userPermissionsFilter.admin"
			v-loading="pageLoading" :element-loading-text="loadingText" element-loading-spinner="el-icon-loading"
			element-loading-background="rgba(0, 0, 0, 0.8)">
			<resize-observer @notify="__resizeHanlder" />
			<div class="avatar-box">
				<img :src="CustomerProfilePicture" alt="user avatar" height="100">
				<!--<div class="star" @click="checkActive">
								<i class="mdi mdi-checkbox-marked-circle align-vertical-middle" v-if="userdata.active"></i>
								<i class="mdi mdi-checkbox-blank-circle-outline align-vertical-middle" v-if="!userdata.active"></i>
							</div>-->
				<div v-if="userPermissionsFilter.addtransactions"><span></span>
					<div class="el-input"><a class="el-button ml-10 el-button--success"
							v-if="userdata.userID && userdata.kycConfirmation == 'Confirmed'"
							:href="'../addtransaction/' + userdata.userID">Send Money</a></div>
				</div>
			</div>

			<div class="form-box">
				<div class="row">
					<el-row :gutter="24">
						<el-col :span="24">
							<strong>User Type: </strong>
							<span v-if="this.userdata.isOrganization == false">Individual</span>
							<span v-if="this.userdata.isOrganization == true">Company</span>
						</el-col>
					</el-row>
					<el-row :gutter="24">
						<el-col :span="8">
							<strong>Customer ID</strong>
							<el-input placeholder="Customer ID" v-model="userdata.customerNumber" name="customerNumber"
								data-vv-as="customerNumber" :readonly="true"></el-input>
							<transition name="fade"><span class="danger-text">{{ errors.first('customerNumber')
									}}</span>
							</transition>
						</el-col>
						<el-col :span="8">
							<strong>User ID</strong>
							<el-input placeholder="User ID" v-model="userdata.userID" name="userID" data-vv-as="userID"
								:readonly="true"></el-input>
							<transition name="fade"><span class="danger-text">{{ errors.first('userID') }}</span>
							</transition>
						</el-col>
						<el-col :span="8">
							<strong>Date Registered</strong>
							<el-input placeholder="Date Registered" v-model="userdata.createdOn" :readonly="true"
								name="createdOn" data-vv-as="createdOn"></el-input>
							<transition name="fade"><span class="danger-text">{{ errors.first('createdOn') }}</span>
							</transition>
						</el-col>

					</el-row>
					<el-row :gutter="24" v-if="this.userdata.isOrganization == false">
						<el-col :span="6">
							<strong>First Name</strong>
							<el-input placeholder="First Name" v-model="userdata.firstName" :readonly="true"
								@change="propertyChanged" name="firstName" data-vv-as="firstName"></el-input>
							<transition name="fade">
								<span class="danger-text">{{ errors.first('firstName') }}</span>
							</transition>
						</el-col>
						<el-col :span="6">
							<strong>Middle Name</strong>
							<el-input placeholder="Middle Name" v-model="userdata.middleName" :readonly="true"
								@change="propertyChanged" name="middleName" data-vv-as="middleName"></el-input>
							<transition name="fade">
								<span class="danger-text">{{ errors.first('middleName') }}</span>
							</transition>
						</el-col>
						<el-col :span="6">
							<strong>Last Name</strong>
							<el-input placeholder="Last Name" v-model="userdata.lastName" :readonly="true"
								@change="propertyChanged" name="lastName" data-vv-as="lastName"></el-input>
							<transition name="fade">
								<span class="danger-text">{{ errors.first('lastName') }}</span>
							</transition>
						</el-col>
						<el-col :span="6">
							<strong>Phone Number <button @click="phoneChanged($event)"><i data-v-03eedf9e=""
										class="mdi mdi-eye"></i></button></strong>
							<VuePhoneNumberInput v-model="plainphone" color="dodgerblue" style="line-height:1"
								:default-country-code="countrycode" :disabled=true class="mb-2" :readonly="true"
								@update="onUpdatePhoneNumber" />
							<!--
										<el-input placeholder="phoneNumber" :maxlength="12" v-model="userdata.phoneNumber" :readonly="true" style="-webkit-text-security: disc"
										name="phoneNumber" v-validate="'required'" data-vv-as="phoneNumber" v-on:blur="updatePhoneNo"></el-input>-->
							<transition name="fade">
								<span class="danger-text">{{ errors.first('phoneNumber') }}</span>
							</transition>
						</el-col>
					</el-row>
					<el-row :gutter="24" v-if="this.userdata.isOrganization == true">
						<el-col :span="24">
							<strong>Company Name: <span :class="required">*</span></strong>
							<el-input placeholder="Company Name" v-model="userdata.organizationName"
								name="organizationName" v-validate="'required'" :readonly="true"
								data-vv-as="organizationName"></el-input>
							<transition name="fade"><span class="danger-text">{{ errors.first("organizationName")
									}}</span>
							</transition>
						</el-col>
					</el-row>
					<el-row :gutter="24">
						<el-col :span="6">
							<strong>Country: <span :class="required">*</span></strong>
							<el-select v-model="userdata.countryID" filterable clearable
								placeholder="Registration Country" class="mb-10" style="width:100%" name="countryID"
								v-validate="'required'" data-vv-as="countryID" @change="countryChanged($event)"
								:readonly="true" :disabled="true">
								<el-option v-for="country in opcountries" :key="country.id" :label="country.name"
									:value="country.id"></el-option>
							</el-select>
							<transition name="fade"> <span class="danger-text">{{ errors.first("countryID") }}</span>
							</transition>
						</el-col>
						<el-col :span="6">
							<span>State</span>
							<span :class="required">*</span>
							<el-select v-model="userdata.state" filterable clearable placeholder="State"
								style="width:100%" name="rState" data-vv-as="state"
								@change="receivingStateChanged($event)">
								<el-option v-for="mProvider in States" :key="mProvider.Id" :label="mProvider.Name"
									:value="mProvider.Name"></el-option>
							</el-select>
							<transition name="fade"><span class="danger-text">{{ errors.first('rState') }}</span>
							</transition>
						</el-col>
						<el-col :span="6">
							<span>City</span>
							<span :class="required">*</span>
							<el-select v-model="userdata.city" filterable clearable placeholder="City"
								style="width:100%" name="rcity" data-vv-as="city">
								<el-option v-for="mProvider in Cities" :key="mProvider.Id" :label="mProvider.Name"
									:value="mProvider.Name"></el-option>
							</el-select>
							<transition name="fade"><span class="danger-text">{{ errors.first('rcity') }}</span>
							</transition>
						</el-col>
						<el-col :span="6">
							<strong>Postal Address: <span :class="required">*</span></strong>
							<el-input type="text" placeholder="Postal Address" v-model="userdata.postalAddress"
								name="PostalAddress" v-validate="'required'" data-vv-as="PostalAddress"></el-input>
							<transition name="fade"><span class="danger-text">{{ errors.first("PostalAddress") }}</span>
							</transition>
						</el-col>
						<el-col :span="6">
							<strong>Address</strong>
							<el-input placeholder="Address" v-model="userdata.address" name="address"
								data-vv-as="address"></el-input>
							<transition name="fade"><span class="danger-text">{{ errors.first('address') }}</span>
							</transition>
						</el-col>

						<el-col :span="6" v-if="this.userdata.isOrganization == false">
							<strong>Gender: <span :class="required">*</span></strong>
							<el-select v-model="userdata.gender" filterable clearable placeholder="Select Gender"
								class="mb-10" style="width:100%" name="gender" v-validate="'required'"
								data-vv-as="Gender" :readonly="true">
								<el-option label="Male" value="Male"></el-option>
								<el-option label="Female" value="Female"></el-option>
								<el-option label="Other" value="Undefined"></el-option>
							</el-select>
							<transition name="fade"><span class="danger-text">{{ errors.first("gender") }}</span>
							</transition>
						</el-col>
						<el-col :span="6">
							<strong v-if="this.userdata.isOrganization == true">Core Business <span
									:class="required">*</span></strong>
							<strong v-else>Occupation <span :class="required">*</span></strong>
							<el-input type="text" placeholder="Occupation" v-model="userdata.occupation"
								name="occupation" v-validate="'required'" data-vv-as="Occupation"></el-input>
							<transition name="fade"><span class="danger-text">{{ errors.first("occupation") }}</span>
							</transition>
						</el-col>
						<el-col :span="6" v-if="this.userdata.isOrganization == false">
							<strong>Date of Birth <span :class="required">*</span></strong>
							<el-date-picker style="width: 100%" v-validate="'required'" v-model="userdata.dob"
								type="date" format="yyyy-MM-dd"
								:picker-options="{ disabledDate: disableLessThan18Dates }" placeholder="Date of Birth"
								name="dob" data-vv-as="Date of Birth"></el-date-picker>
							<transition name="fade">
								<span class="danger-text">{{ errors.first('dob') }}</span>
							</transition>
						</el-col>
						<el-col :span="6" v-if="this.userdata.isOrganization == true">
							<strong>Phone Number <button @click="phoneChanged($event)"><i data-v-03eedf9e=""
										class="mdi mdi-eye"></i></button></strong>
							<VuePhoneNumberInput v-model="plainphone" color="dodgerblue" style="line-height:1"
								:default-country-code="countrycode" :disabled=true class="mb-2"
								@update="onUpdatePhoneNumber" />
							<!-- <el-input placeholder="phoneNumber" :maxlength="12" v-model="userdata.phoneNumber" :readonly="false" style="-webkit-text-security: disc"
								name="phoneNumber" v-validate="'required'" data-vv-as="phoneNumber" v-on:blur="updatePhoneNo"></el-input>-->
							<transition name="fade">
								<span class="danger-text">{{ errors.first('phoneNumber') }}</span>
							</transition>
						</el-col>

						<el-col :span="6" v-if="this.userdata.isOrganization == true">
							<strong>Date of Incorporation <span :class="required">*</span></strong>
							<el-date-picker style="width: 100%" v-validate="'required'" v-model="userdata.dob"
								type="date" format="yyyy-MM-dd"
								:picker-options="{ disabledDate: disableAllDatesAfterToday }"
								placeholder="Date of Incorporation" name="dob"
								data-vv-as="Date of Incorporation"></el-date-picker>
							<transition name="fade">
								<span class="danger-text">{{ errors.first('dob') }}</span>
							</transition>
						</el-col>
					</el-row>

					<el-row :gutter="24" v-if="this.userdata.isOrganization == false">
						<el-col :span="6">
							<strong>Nationality <span :class="required">*</span></strong>
							<el-select v-model="userdata.nationality" filterable clearable placeholder="Nationality"
								class="mb-10" style="width:100%" name="nationality" v-validate="'required'"
								data-vv-as="nationality">
								<el-option v-for="nationality in nationalities" :key="nationality.index"
									:label="nationality" :value="nationality"></el-option>
							</el-select>
							<transition name="fade">
								<span class="danger-text">{{ errors.first('nationality') }}</span>
							</transition>
						</el-col>
						<el-col :span="6">
							<strong>Document Type: <span :class="required">*</span></strong>
							<el-select v-model="userdata.documentTypeID" filterable clearable
								placeholder="Select Document Type" class="mb-10" style="width:100%"
								name="documentTypeID" v-validate="'required'" data-vv-as="documentTypeID"
								:readonly="true">
								<el-option v-for="documentType in documentTypes" :key="documentType.id"
									:label="documentType.name" :value="documentType.id"></el-option>
							</el-select>
							<transition name="fade"> <span class="danger-text">{{ errors.first("documentTypeID")
									}}</span>
							</transition>
						</el-col>
						<el-col :span="6">
							<strong>ID Number: <span :class="required">*</span></strong>
							<el-input placeholder="ID Number" v-model="userdata.idNumber" @change="propertyChanged"
								name="idNumber" v-validate="'required'" data-vv-as="idNumber"></el-input>
							<transition name="fade">
								<span class="danger-text">{{ errors.first('idNumber') }}</span>
							</transition>
						</el-col>
						<el-col :span="6">
							<strong>Document Expiry Date</strong>
							<el-date-picker style="width: 100%" v-model="userdata.expiryDate" type="date"
								format="yyyy-MM-dd" :picker-options="{ disabledDate: disableAllDatesBeforeToday }"
								placeholder="Document Expiry Date" name="expiryDate"
								data-vv-as="document expiry date"></el-date-picker>
							<transition name="fade"><span class="danger-text">{{ errors.first('expiryDate') }}</span>
							</transition>
						</el-col>
					</el-row>
					<el-row :gutter="24" v-if="this.userdata.isOrganization == true">
						<el-col :span="8">
							<strong>Document Type: <span :class="required">*</span></strong>
							<el-select v-model="userdata.documentTypeID" filterable clearable
								placeholder="Select Document Type" class="mb-10" style="width:100%"
								name="documentTypeID" v-validate="'required'" data-vv-as="documentTypeID">
								<el-option v-for="documentType in documentTypes" :key="documentType.id"
									:label="documentType.name" :value="documentType.id"></el-option>
							</el-select>
							<transition name="fade"> <span class="danger-text">{{ errors.first("documentTypeID")
									}}</span>
							</transition>
						</el-col>
						<el-col :span="8">
							<strong>Company Registration Number: <span :class="required">*</span></strong>
							<span v-for="doc in documentTypes" :key="doc.id"><span
									v-if="doc.id == userdata.documentTypeID">({{ doc.name
									}})</span></span>
							<el-input placeholder="Company Registration Number" v-model="userdata.idNumber"
								name="idNumber" v-validate="'required'" data-vv-as="idNumber"></el-input>
							<transition name="fade"><span class="danger-text">{{ errors.first("idNumber") }}</span>
							</transition>
						</el-col>
						<el-col :span="8">
							<strong>Document Expiry Date</strong>
							<el-date-picker style="width: 100%" v-model="userdata.expiryDate" type="date"
								format="yyyy-MM-dd" :picker-options="{ disabledDate: disableAllDatesBeforeToday }"
								placeholder="Document Expiry Date" name="expiryDate"
								data-vv-as="document expiry date"></el-date-picker>
							<transition name="fade"><span class="danger-text">{{ errors.first('expiryDate') }}</span>
							</transition>
						</el-col>
					</el-row>
					<el-row :gutter="24">
						<el-col :span="8">
							<strong>KYC Status: <span :class="required">*</span></strong>
							<el-select v-model="userdata.kycConfirmation" placeholder="KYC Status" style="width:100%"
								name="kycConfirmation" v-validate="'required'" data-vv-as="kycConfirmation">
								<el-option v-for="kycstatus in kycstatuses" :key="kycstatus" :label="kycstatus"
									:value="kycstatus">
								</el-option>
							</el-select>
							<transition name="fade">
								<span class="danger-text">{{ errors.first('kycConfirmation') }}</span>
							</transition>
						</el-col>
						<el-col :span="8">
							<strong>Failure Reason</strong>
							<el-select v-model="userdata.kycFailureReason" filterable clearable
								placeholder="Failure Reason" class="mb-10" style="width:100%" name="kycFailureReason"
								data-vv-as="kycFailureReason">
								<el-option v-for="failureR in failureReasons" :key="failureR" :label="failureR"
									:value="failureR"></el-option>
							</el-select>
							<transition name="fade">
								<span class="danger-text">{{ errors.first('kycFailureReason') }}</span>
							</transition>
						</el-col>
						<el-col :span="8">
							<strong>Other KYC Comments</strong>
							<el-input placeholder="input your comment" v-model="userdata.kycComments" name="kycComments"
								data-vv-as="kycComments"></el-input>
							<transition name="fade">
								<span class="danger-text">{{ errors.first('kycComments') }}</span>
							</transition>
						</el-col>
					</el-row>
					<hr />

					<el-row :gutter="24" v-if="this.userdata.isOrganization == false" class="pt-12">
						<el-col :span="6">
							<input type="file" id="files" ref="files" accept=".jpg, .jpeg, .png, .pdf"
								v-on:change="handleIndividualFilesUpload()" style="display: none" />
							<el-button type="warning" class="btn-group" v-show="userPermissionsFilter.approveusers"
								@click="addIndividualFiles($event, 'ID')"><i class="mdi mdi-account-check"></i><span>
									Upload
									ID Front Side</span></el-button>
						</el-col>
						<el-col :span="6">
							<input type="file" id="files" ref="files" accept=".jpg, .jpeg, .png, .pdf"
								v-on:change="handleIndividualFilesUpload()" style="display: none" />
							<el-button type="warning" class="btn-group" v-show="userPermissionsFilter.approveusers"
								@click="addIndividualFiles($event, 'ID-B')"><i class="mdi mdi-account-check"></i><span>
									Upload ID Back Side</span></el-button>
						</el-col>
						<el-col :span="6"
							v-if="this.userdata.nationality != 'Kenyan' || this.userdata.nationality != 'Ugandan'">
							<input type="file" id="files" ref="files" accept=".jpg, .jpeg, .png, .pdf"
								v-on:change="handleIndividualFilesUpload()" style="display: none" />
							<el-button type="warning" class="btn-group" v-show="userPermissionsFilter.approveusers"
								@click="addIndividualFiles($event, 'WORK_PERMIT')"><i
									class="mdi mdi-account-check"></i><span> Upload Work Permit</span></el-button>
						</el-col>
						<el-col :span="6"
							v-if="this.userdata.nationality != 'Kenyan' || this.userdata.nationality != 'Ugandan'">
							<input type="file" id="files" ref="files" accept=".jpg, .jpeg, .png, .pdf"
								v-on:change="handleIndividualFilesUpload()" style="display: none" />
							<el-button type="warning" class="btn-group" v-show="userPermissionsFilter.approveusers"
								@click.prevent="addIndividualFiles($event, 'SPECIAL_PASS')"><i
									class="mdi mdi-account-check"></i><span> Upload Special Pass</span></el-button>
						</el-col>
					</el-row>

					<el-row :gutter="24" v-if="this.userdata.isOrganization == false && this.iDFile">
						<el-col :span="24">
							<div :gutter="24" class="col-md-4">
								<embed class="el-col el-col-6" v-for=" pdf in this.iDFile" :key="pdf.id"
									v-bind:src="pdf.url" v-show="showPreview" width="100%" height="350">
							</div>
						</el-col>
					</el-row>
					<el-row :gutter="24" v-if="this.userdata.isOrganization == false" class="pt-22">
						<el-col :span="24" v-if="this.uploadedDocs.length > 0">
							<h3>Uploaded existing documents</h3>
							<div :gutter="24" class="col-md-3 el-col el-col-6" v-for=" pdf in this.uploadedDocs"
								:key="pdf.item1" style="padding-left: 12px; padding-right: 12px;">
								<h5>{{ pdf.item2 }}</h5>
								<embed class="el-col" v-if="pdf.item3 === 'pdf'" v-bind:src="pdf.item4"
									v-show="showPreview" width="100%" height="350">
								<a data-magnify="gallery" :data-caption="pdf.item2" :href="pdf.item4"
									v-if="pdf.item3 === 'image'">
									<img v-bind:src="pdf.item4"
										style="max-height: 350px;height:auto;width: auto;max-width: 100%;">
								</a>
							</div>
						</el-col>
						<el-col :span="24" v-else>
							<span>No documents were found</span><br />
							<el-button type="warning" class="btn-group" @click.prevent="redownloadDocuments()"><i
									class="mdi mdi-account-check"></i><span> Download Metamap
									Documents</span></el-button>
						</el-col>
					</el-row>
					<!-- <el-row :gutter="24" v-if="this.userdata.isOrganization == false" class="pt-22">
						<el-col :span="6">
							<strong>ID /or Passport/ or Allien ID</strong>
							<div class="col col-md-12" v-if="IdProfile">
								<a data-magnify="gallery" :data-caption="userdata.fullName" :href="IdProfile">
									<img :src="IdProfile" alt="ID"
										style="max-height: 400px;height:auto;width: auto;max-width: 100%;">
								</a>
							</div>
							<div class="col col-md-12" v-else><small>Ooops, Nothing here</small></div>
						</el-col>
						<el-col :span="6">
							<strong>Back of ID</strong>
							<div class="col col-md-12" v-if="IdBackProfile">
								<a data-magnify="gallery" :data-caption="userdata.fullName" :href="IdBackProfile">
									<img :src="IdBackProfile" alt="ID"
										style="max-height: 400px;height:auto;width: auto;max-width: 100%;">
								</a>
							</div>
							<div class="col col-md-12" v-else><small>Ooops, Nothing here</small></div>
						</el-col>
						<el-col :span="6"
							v-if="this.userdata.nationality != 'Kenyan' || this.userdata.nationality != 'Ugandan'">
							<strong>Work Permit</strong>
							<div class="col col-md-12" v-if="wrkPermit">
								<a data-magnify="gallery" :data-caption="userdata.fullName" :href="wrkPermit">
									<img :src="wrkPermit" alt="Work Permit"
										style="max-height: 400px;height:auto;width: auto;max-width: 100%;">
								</a>
							</div>
							<div class="col col-md-12" v-else><small>Ooops, Nothing here</small></div>
						</el-col>
						<el-col :span="6"
							v-if="this.userdata.nationality != 'Kenyan' || this.userdata.nationality != 'Ugandan'">
							<strong>Special Pass</strong>
							<div class="col col-md-12" v-if="specialPass">
								<a data-magnify="gallery" :data-caption="userdata.fullName" :href="specialPass">
									<img :src="specialPass" alt="Special Pass"
										style="max-height: 400px;height:auto;width: auto;max-width: 100%;">
								</a>
							</div>
							<div class="col col-md-12" v-else><small>Ooops, Nothing here</small></div>
						</el-col>
					</el-row> -->

					<el-row :gutter="24" v-if="this.userdata.isOrganization == true">
						<el-col :span="24">
							<el-row :gutter="24">
								<el-col :span="24">
									<span>Re-Upload following documents for verification (<small>Allowed document type
											are
											images and pdf only</small>)</span>
									<input type="file" id="files" ref="files" accept="application/pdf, .pdf"
										v-on:change="handleFilesUpload()" style="display: none" />
								</el-col>
							</el-row>

							<el-row :gutter="24" class="list-group list-group-flush">
								<el-col :span="8" v-for="doc in documentTypes" :key="doc.id">
									<button href="javascript:0;" type="button"
										class="el-col el-col-24 el-button btn btn-primary el-button--primary"
										style="padding-left: 12px; padding-right: 12px" :data-id="doc.id"
										v-on:click="addFiles($event, doc.id)">
										Upload {{ doc.name }}
									</button>
								</el-col>
							</el-row>

							<el-row :gutter="24" class="list-group list-group-flush">
								<el-col :span="8" v-for="pdf in this.pdfSrc" :key="pdf.name">
									<embed class="el-col el-col-24" v-bind:src="pdf.url" v-show="showPreview"
										width="100%" height="350" />
								</el-col>
							</el-row>
							<br />
							<hr />
							<el-row :gutter="24">
								<el-col :span="24" v-if="this.uploadedDocs.length > 0">
									<h3>Uploaded existing documents</h3>
									<div :gutter="24" class="col-md-4 el-col el-col-8" v-for=" pdf in this.uploadedDocs"
										:key="pdf.item1" style="padding-left: 12px; padding-right: 12px;">
										<h5>{{ pdf.item2 }}</h5>
										<embed class="el-col" v-if="pdf.item3 === 'pdf'" v-bind:src="pdf.item4"
											v-show="showPreview" width="100%" height="350">
										<a data-magnify="gallery" :data-caption="pdf.item2" :href="pdf.item4"
											v-if="pdf.item3 === 'image'">
											<img v-bind:src="pdf.item4" v-if="pdf.item3 === 'image'"
												style="max-height: 350px;height:auto;width: auto;max-width: 100%;">
										</a>
									</div>
								</el-col>
								<el-col :span="24" v-else>
									<span>No documents were found</span>
								</el-col>
							</el-row>

						</el-col>
					</el-row>


					<div class="row mt-12" v-show="userdata.id != null && userPermissionsFilter.viewuserscompliance">
						<div class="col col-md-12">
							<el-button type="primary" class="btn-group" style="width:24%"
								v-show="userPermissionsFilter.approveusers" @click="updateUserKyc">
								<i class="mdi mdi-account-check"></i><span> Update KYC</span>
							</el-button>
							<el-button type="danger" class="btn-group" style="width:24%"
								v-show="userPermissionsFilter.deleteuserkyc" @click="deleteUsersProfiles">
								<i class="mdi mdi-delete"></i><span> Delete</span>
							</el-button>
							<el-button type="warning" class="btn-group" style="width:24%"
								v-show="userPermissionsFilter.rejectusers" @click="rejectUsersProfiles">
								<i class="mdi mdi-cancel"></i><span> Reject</span>
							</el-button>
							<!--<el-button type="success" class="btn-group" style="width:24%"
								v-show="userPermissionsFilter.approveusers" @click="approveUsersProfiles">
								<i class="mdi mdi-account-check"></i><span> Approve</span>
							</el-button>
							 <el-button  type="primary" class="btn-group" style="width:30%" v-show="userPermissionsFilter.approveusers" @click="GoToCompanyDocs(userdata.userID, $event)" v-if="userdata.IsOrganization == 1 && this.userdata.UserID">
								<i class="mdi mdi-account-check"></i><span> Add Company Documents</span>
							</el-button> -->

							<!--<el-button  type="primary" class="btn-group" style="width:30%" v-show="userPermissionsFilter.approveusers" @click="GoToAddADirector(userdata.userID, $event)"  v-if="userdata.IsOrganization == 1 && this.userdata.UserID">
								<i class="mdi mdi-account-check"></i><span> Add Company Directors</span>
							</el-button>-->
						</div>

					</div>
				</div>
			</div>

		</div>
	</vue-scroll>
</template>

<script>
import PermissionsMixins from "@/mixins/PermissionsMixins";
import { Validator } from "vee-validate";
import moment from "moment";
import router from "@/router/";

import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

export default {
	name: "UsersComplianceView",
	components: {
		VuePhoneNumberInput,
	},
	data() {
		return {
			pdfSrc: [],
			plainphone: "**********",
			countrycode: "",
			iDFile: [], //reupload id for customer
			file: undefined,
			filename: "",
			opcountries: [],
			files: [],
			States: [],
			Cities: [],
			identityDocumentTypes: [],
			kycstatuses: ['Pending', 'Confirmed', 'Pending Additional Documents', 'Failed', 'Expired', 'Rejected'],
			showPreview: false,
			uploadedDocs: {
				item1: "",
				item2: "",
				item3: "",
				item4: ""
			},
			DocumentUpload: {
				DocumentId: "",
				userId: "",
				files: ""
			},
			//edited adata
			editedKycProfile: {
				userID: "",
				state: "",
				city: "",
				postalAddress: "",
				address: "",
				occupation: "",
				nationality: "",
				documentTypeID: 0,
				idNumber: "",
				kycConfirmation: "",
				kycFailureReason: "",
				kycComments: "",
				expiryDate: "",
			},
			failureReasons: ["Wrong-Documents", "IPRS-Error", "Expired-Documents", "Customer-Error", "System-Error", "Pending Additional Documents", "Manual Approval", "Other"],
			search: "",
			pageWidth: 0,
			userdata: {
				id: "",
				isOrganization: "",
				active: "",
				customerNumber: "",
				userID: "",
				phoneNumber: "",
				createdOn: "",
				state: "",
				city: "",
				postalAddress: "",
				address: "",
				occupation: "",
				fullName: "",
				gender: "",
				organizationName: "",
				countryID: "",
				kycComments: "",
				kycConfirmation: "",
				kycFailureReason: "",
				documentTypeID: 0,
				idNumber: "",
				nationality: "",
				dob: "",
				expiryDate: ""
			},
			CustomerProfilePicture: 'data:image/jpeg;base64,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'
		}
	},
	computed: {
		readOnlyMode() {
			return !this.userPermissionsFilter.addusers && !this.userPermissionsFilter.editusers;
		}
	},
	methods: {
		setPageWidth() {
			this.pageWidth = document.getElementById('page-contacts').offsetWidth
		},
		__resizeHanlder: _.throttle(function (e) {
			this.setPageWidth()
		}, 700),
		rejectUsersProfiles() {
			this.startLoader("Saving User...");
			if (!this.userdata.kycFailureReason) {
				this.errorMessage('Failure Reason is null, fill all the required input fields!')
				return
			}
			this.disapproveUser(this.userdata.userID, this.userdata.kycFailureReason)
				.then(result => {
					this.stopLoader();
					if (result) {
						this.successMessage('User has been Rejected.');
						this.fetchUser();
					}
				})
				.catch((err) => {
					this.stopLoader();
					console.log(err);
					this.errorMessage("An error occured.");
				});
		},
		redownloadDocuments() {
			this.startLoader("Trying to get documents for the user ...");
			if (!this.userdata.userID) {
				this.errorMessage('User does not exist!')
				return
			}
			this.redownloadMetaMapKYCDocuments(this.userdata.userID)
				.then(result => {
					this.stopLoader();
					if (result.code === "200") {
						this.successMessage('User documents have been Updated.');
						this.fetchUser();
					}
					else {
						this.errorMessage("Failed to update KYC Documents.");
					}
				})
				.catch((err) => {
					this.stopLoader();
					console.log(err);
					this.errorMessage("An error occured.");
				});
		},
		deleteUsersProfiles() {
			if (confirm("Do you really want to delete?")) {
				this.startLoader("Saving User...");
				this.deleteUserKYC(this.userdata.userID)
					.then(result => {
						this.stopLoader();
						if (result) {
							this.successMessage('User kyc has been Deleted.');
							this.fetchUser();
						}
					})
					.catch((err) => {
						this.stopLoader();
						console.log(err);
						this.errorMessage("An error occured.");
					});
			}
		},
		GoToCompanyDocs(id, $event) {
			router.push("/AddCustomerDocuments/" + id);
		},

		GoToAddADirector(id, $event) {
			router.push("/AddADirector/" + id);
		},
		// async approveUsersProfiles() {
		// 	this.startLoader("Saving User...");
		// 	var newDate = moment().add(3, 'Y').subtract(1, 'day').format('DD-MM-YYYY');
		// 	if (this.userdata.expiryDate === "null" || this.userdata.expiryDate === null || this.userdata.expiryDate === "") {
		// 	}
		// 	else {
		// 		this.newDate = moment(this.userdata.expiryDate, 'DD/MM/YYYY').format('DD-MM-YYYY');//20/09/2027
		// 	}
		// 	this.$validator.validateAll().then((result) => {
		// 		if (result) {
		// 			if (!this.$validator.errors.has("userID") && !this.$validator.errors.has("kycComments") && !this.$validator.errors.has("kycFailureReason")) {
		// 				this.approveUser(this.userdata.userID, this.userdata.kycComments, newDate, this.userdata.kycFailureReason).then(result => {
		// 					this.stopLoader();
		// 					if (result) {
		// 						this.successMessage('User has been approved.');
		// 						this.fetchUser();
		// 					}
		// 					else {
		// 						this.errorMessage('Error: User was not approved.');
		// 					}
		// 				})
		// 					.catch((err) => {
		// 						this.stopLoader();
		// 						console.log(err);
		// 						this.errorMessage("An error occured.");
		// 					});
		// 			}
		// 			else {
		// 				this.errorMessage("Kindly fill the required fields.");
		// 			}
		// 		}
		// 	}).catch((err) => {
		// 		this.stopLoader();
		// 		console.log(err);
		// 		this.errorMessage("An error occured.");
		// 	});
		// },
		async updateUserKyc() {
			for (let key in this.editedKycProfile) {
				// Check if the key exists in userdata and their values are the same type
				if (
					this.userdata.hasOwnProperty(key) &&
					typeof this.editedKycProfile[key] === typeof this.userdata[key]
				) {
					// Assign the value from userdata to editedKycProfile
					this.editedKycProfile[key] = this.userdata[key];
				}
			}
			// validate
			if (!this.$validator.errors.has('userID') &&
				!this.$validator.errors.has('kycConfirmation')) {
				this.$validator.reset();
				//now check nulls
				if (!this.editedKycProfile.userID || !this.editedKycProfile.kycConfirmation || !this.editedKycProfile.idNumber) {
					this.errorMessage('Null fields detected, fill all the required input fields!')
					return
				}
				if (this.editedKycProfile.kycConfirmation == "Confirmed" && !this.userdata.idNumber) {
					this.errorMessage('Kyc cannot be confirmed without user Identification Number!')
					return
				}
				var dt = '';
				if (this.userdata.expiryDate === "null" || this.userdata.expiryDate === null || this.userdata.expiryDate === "" || this.userdata.expiryDate === "Invalid date" || this.userdata.expiryDate === "Undefined") {
					dt = "";
				}
				else {
					dt = moment(this.userdata.expiryDate).format('YYYY-MM-DD');
				}
				this.editedKycProfile.expiryDate = dt;
				this.startLoader("Updating User Details...");
				const uploadSuccess = await this.UploadKYCDocs(this.editedKycProfile);
				if (uploadSuccess) {
					this.editUserKyc(this.editedKycProfile)
						.then(result => {
							if (result.success == false) {
								this.errorMessage(result.errors[0].description);
							}
							else {
								setTimeout(() => {
									this.fetchUser();
									this.successMessage('User kyc has been Updated.');
								}, 2000);
							}
						})
						.catch((error) => {
							if (error.response) {
								// The request was made and the server responded with a status code
								this.errorMessage(error.response.data.errors[0].description);
							} else if (error.request) {
								this.errorMessage("An error occured.");
							} else {
								this.errorMessage("An error occured.");
							}
							this.stopLoader();
						});
					this.stopLoader();
				}
				else {
					this.errorMessage("An error  when trying to update kyc. All Documents missing");
					this.stopLoader();
				}
			}
			else {
				this.errorMessage('Form has some errors, check on the mandatory fields!');
				this.stopLoader();
			}
		},
		countryChanged(event) {
			const codesn = this.opcountries.map((err) => {
				if (err.id == event) {
					this.countrycode = err.code;
					return err.code;
				}
				else {
				}
			});
			this.getStates(event).then((result) => {
				this.States = result;
			})
				.catch((err) => {
					console.log(err);
				});
		},
		receivingStateChanged(event) {
			let statecode = '';
			const codesn = this.States.map((err) => {
				if (err.Name == event) {
					statecode = err.Id;
					return err.code;
				}
				else {
				}
			});
			this.getCities(this.userdata.countryID, statecode).then((result) => {
				this.Cities = result;
			})
				.catch((err) => {
					console.log(err);
				});
		},
		getCurrentCity(countryID, state) {
			let statecode = '';
			const codesn = this.States.map((err) => {
				if (err.Name == state) {
					statecode = err.Id;
					return err.code;
				}
				else {
				}
			});
			this.getCities(countryID, statecode).then((result) => {
				this.Cities = result;
			})
				.catch((err) => {
					console.log(err);
				});
		},
		updatePhoneNo() {
			this.editKycPhonenumber(this.editedKycProfile)
				.then(result => {
					if (result) {
						this.successMessage('User Phone edited successfully!');
					}
				}).catch(err => this.errorMessage('Error occured while updating phone number!'));
		},
		phoneChanged(event) {
			this.plainphone = this.userdata.phoneNumber;
			let data = {
				UserId: this.userdata.userID,
				Action: "PhoneNumber",
				CustomerInfo: this.userdata.id,
				Description: "Viewing Customer Phone Number",
			}
			this.saveInfoRequest(data).then((result) => {
			}).catch((err) => { console.log(err); });
		},
		onUpdatePhoneNumber(payload) {
			//this.userdata.phoneNumber = payload.formattedNumber;
			// if(payload.isValid){
			//   this.userdata.phoneNumber = payload.formattedNumber;
			// }
			// else{
			//   this.$validator.errors.add({
			//     field: 'phoneNumber',
			//     msg: 'Invalid Phone Number Credentials'
			//   });
			// }
		},
		addIndividualFiles: function (event, id) {
			this.$refs.files.click();
			//this.filename= event.target.dataset.id;
			//this.filename = event.target.getAttribute('data-id');
			this.filename = id;
		},

		addFiles: function (event, id) {
			this.$refs.files.click();
			this.filename = id;
			//this.filename= event.target.dataset.id;
		},

		// file handler: mbuvi
		handleIndividualFilesUpload() {
			let uploadedFiles = this.$refs.files.files;

			let size = event.target.files[0].size
			this.iDFile.push({ url: URL.createObjectURL(event.target.files[0]), name: this.filename });
			// console.log('upload', uploadedFiles[0].type, xx, this.pdfSrc )
			// validate file size
			if (uploadedFiles[0].size > 10 * 1024 * 1024) {
				alert('Error : Exceeded size 10MB');
				uploadedFiles.splice(0, 1);
			}
			// validate whether PDF
			// if(mime_types.indexOf(file.type) == -1) {
			//     alert('Error : Incorrect file type');
			//     return;
			// }

			/*3
				Adds the uploaded file to the files array
			*/

			for (var i = 0; i < uploadedFiles.length; i++) {
				this.files.push({ file: uploadedFiles[i], name: this.filename });


				/*
				Initialize a File Reader object
			*/
				let reader = new FileReader();
				/*
					Add an event listener to the reader that when the file
					has been loaded, we flag the show preview as true and set the
					image to be what was read from the reader.
				*/
				//  for (var i=0; i<this.files.length; i++){
				reader.addEventListener("load", function () {
					this.showPreview = true;
					this.imagePreview = reader.result;
				}.bind(this), false);
				/*
					Check to see if the file is not empty.
				*/
				if (uploadedFiles[i]) {
					/*
					Ensure the file is an image file.
					*/
					if (/\.(jpe?g|png|gif)$/i.test(uploadedFiles[i].name)) {
						/*
							Fire the readAsDataURL method which will read the file in and
							upon completion fire a 'load' event which we will listen to andthis.userdata.UserID
							display the image in the preview.
						*/
						reader.readAsDataURL(uploadedFiles[i]);
					}
					else if (/\.(pdf)$/i.test(uploadedFiles[i].name)) {
						//  alert('pdf')
						reader.readAsArrayBuffer(uploadedFiles[i]);

					}
				}
				// }


			}
		},
		handleFilesUpload() {
			let uploadedFiles = this.$refs.files.files;
			let size = event.target.files[0].size;
			// validate file size
			if (uploadedFiles[0].size > 10 * 1024 * 1024) {
				alert("Error : Exceeded size 10MB");
				uploadedFiles.splice(0, 1);
			}
			// validate whether PDF
			// if(mime_types.indexOf(uploadedFiles.type) == -1) {
			//     alert('Error : Incorrect file type');
			//     return;
			// }

			/*3
			  Adds the uploaded file to the files array
			*/

			//this.filename=this.filename.replace(/ /g,"_");
			for (var i = 0; i < uploadedFiles.length; i++) {
				const product = this.files.find((p) => p.name === this.filename);
				if (!product) {
					this.pdfSrc.push({
						url: URL.createObjectURL(uploadedFiles[i]),
						name: this.filename,
					});
					this.files.push({ file: uploadedFiles[i], name: this.filename });
				} else {
					this.pdfSrc[i] = {
						url: URL.createObjectURL(uploadedFiles[i]),
						name: this.filename,
					};
					this.files[i] = { file: uploadedFiles[i], name: this.filename };
				}
				/*
				Initialize a File Reader object
			  */
				let reader = new FileReader();
				/*
				Add an event listener to the reader that when the file
				has been loaded, we flag the show preview as true and set the
				image to be what was read from the reader.
			  */
				//  for (var i=0; i<this.files.length; i++){
				reader.addEventListener(
					"load",
					function () {
						this.showPreview = true;
						this.imagePreview = reader.result;
					}.bind(this),
					false
				);
				/*
				Check to see if the file is not empty.
			  */
				if (uploadedFiles[i]) {
					/*
					Ensure the file is an image file.
				  */
					if (/\.(jpe?g|png|gif)$/i.test(uploadedFiles[i].name)) {
						/*
						Fire the readAsDataURL method which will read the file in and
						upon completion fire a 'load' event which we will listen to and
						display the image in the preview.
					  */
						reader.readAsDataURL(uploadedFiles[i]);
					} else if (/\.(pdf)$/i.test(uploadedFiles[i].name)) {
						//  alert('pdf')
						reader.readAsArrayBuffer(uploadedFiles[i]);
					}
				}
				// }
			}
		},
		//id image update
		UploadKYCDocs(userProfile) {
			return new Promise((resolve, reject) => {
				if (this.userdata.isOrganization) {
					if (this.files.length < this.identityDocumentTypes.length) {
						this.errorMessage("Upload all documents.");
						return resolve(false); // Resolve with false
					}

					const uploadPromises = this.files.map(file => {
						const formData = new FormData();
						formData.append("files", file.file); // Ensure 'file.file' is correct
						formData.append("DocumentId", file.name); // Assuming this is the correct key
						formData.append("userId", userProfile.userID);
						return this.uploadCompanyKycDocument(formData);
					});

					Promise.all(uploadPromises)
						.then(results => {
							const failedUploads = results.filter(result => result.code !== "200");
							if (failedUploads.length > 0) {
								failedUploads.forEach((result, index) => {
									this.errorMessage("Failed to upload " + this.files[index].name + " KYC Document.");
								});
								return resolve(false); // Resolve with false if any upload fails
							} else {
								this.successMessage('KYC Document(s) uploaded successfully!');
								return resolve(true); // Resolve with true if all uploads succeed
							}
						})
						.catch(error => {
							this.errorMessage("An error occurred during upload: " + error.message);
							return resolve(false); // Resolve with false on error
						});

				} else {
					if (this.files.length > 0) {
						const uploadPromises = this.files.map(file => {
							const formData = new FormData();
							formData.append("files", file.file); // Ensure 'file.file' is correct
							formData.append("DocumentType", file.name); // Assuming this is the correct key
							formData.append("userId", userProfile.userID);
							return this.uploadIndividualKYCDocs(formData);
						});

						Promise.all(uploadPromises)
							.then(results => {
								const failedUploads = results.filter(result => result.code !== "200");
								if (failedUploads.length > 0) {
									failedUploads.forEach((result, index) => {
										this.errorMessage("Failed to upload " + this.files[index].name + " KYC Document.");
									});
									return resolve(false); // Resolve with false if any upload fails
								} else {
									this.successMessage('KYC Document(s) uploaded successfully!');
									return resolve(true); // Resolve with true if all uploads succeed
								}
							})
							.catch(error => {
								this.errorMessage("An error occurred during upload: " + error.message);
								return resolve(false); // Resolve with false on error
							});
					} else {
						return resolve(true); // Resolve with true if no files to upload
					}
				}
			});
		},

		deactivateUser() {
			this.lockout = false;
			this.activateUser(this.userdata.id, false)
				.then(result => {
					if (result) {
						this.successMessage('User has been deactivated.');
						this.fetchUser();
					}
				})
				.catch(err => this.errorMessage('An error occured.'));
		},
		fetchUser() {
			this.startLoader("Loading User...");
			var id = router.currentRoute.params.id;
			this.getUserKYCProfile(id)
				.then((result) => {
					this.userdata = result.items[0];
					for (let key in this.editedKycProfile) {
						// Check if the key exists in userdata and their values are the same type
						if (
							result.items[0].hasOwnProperty(key) &&
							typeof this.editedKycProfile[key] === typeof result.items[0][key]
						) {
							// Assign the value from userdata to editedKycProfile
							this.editedKycProfile[key] = result.items[0][key];
						}
					}
					//this.editedKycProfile = result.items[0];
					if (result.items[0].expiryDate) {
						this.userdata.expiryDate = moment(result.items[0].expiryDate).format('YYYY-MM-DD');
					}
					if (this.userdata) {
						this.getCustomerPicture(this.userdata.userID);
						const codesn = this.opcountries.map((err) => {
							if (err.id == parseInt(this.userdata.countryID, 10)) {
								this.countrycode = err.code;
								return err.code;
							}
							else {
							}
						});
						this.getStates(this.userdata.countryID).then((result) => {
							this.States = result;
							if (this.userdata.state) {
								this.getCurrentCity(this.userdata.countryID, this.userdata.state);
							}
						}).catch((err) => {
							console.log(err); this.stopLoader();
						});

						if (this.userdata.isOrganization == true) {
							this.customerTypeChanged("1");
							this.getCompanyKycDocuments(this.userdata.userID).then(result => {
								this.uploadedDocs = result.message;
								this.showPreview = true;
								this.stopLoader();
							}).catch(err => { this.errorMessage("User documents were not found. " + err); this.stopLoader(); });
						}
						else {
							this.customerTypeChanged("0");
							this.getIndividualKYCDocuments(this.userdata.userID).then(result => {
								this.uploadedDocs = result.message;
								this.showPreview = true;
								this.stopLoader();
							}).catch(err => { this.errorMessage("User documents were not found. " + err); this.stopLoader(); });
							// this.getIdPicture(this.userdata.userID);
							// this.getBackIdPicture(this.userdata.userID);
							// this.getWorkPermitPicture(this.userdata.userID);
							// this.getSpecialpassPicture(this.userdata.userID);
							// this.stopLoader();
						}
					}
				}).catch((err) => { console.log(err); this.stopLoader(); });
		},
		customerTypeChanged(e) {
			if (e === '1') {
				this.getDocumentTypesByCountryId(0, this.userdata.countryID).then((documentTypes) => {
					this.CustomerType = "Company";
					this.identityDocumentTypes = documentTypes;
				})
					.catch((err) => {
						this.errorMessage("An error occured");
					});

			} else if (e === '0') {
				this.getDocumentTypesByCountryId(1, this.userdata.countryID).then((documentTypes) => {
					this.CustomerType = "Individual";
					this.identityDocumentTypes = documentTypes;
				})
					.catch((err) => {
						this.errorMessage("An error occured");
					});
			}
		},

		saveCurrentUser() {
			let self = this;
			if (!this.$validator.errors.has('firstname') &&
				!this.$validator.errors.has('lastname') &&
				!this.$validator.errors.has('email') &&
				!this.$validator.errors.has('phone')) {
				this.$validator.reset();
				this.saveUser(this.userdata)
					.then(result => {
						if (result.id.length > 0) {
							this.fetchUser();
							this.successMessage('User saved successfully.');
						}
					})
					.catch(err => this.errorMessage('Failed to create user.'));
			}
		},
		checkActive() {
			if (!this.readOnlyMode) {
				this.userdata.active = !this.userdata.active
			}
		}

	},
	mounted() {
		//this.getCompanyNames();
		this.setPageWidth()
	},
	created() {
		const that = this;
		that.saveEvent = 'saveCurrentUser';
		that.getLoggedInCompany().then((loggedInCompany) => {
			that.startLoader("Loading ...");
			that.getUserOperationalCountries().then((opcntry) => {
				that.opcountries = opcntry;
				that.fetchUser();
				that.$on(that.saveEvent, that.saveCurrentUser);
				that.getNationalities().then((result) => {
					that.nationalities = result;
					that.stopLoader();
				}).catch((err) => {
					that.errorMessage("An Error Occured. " + err); that.stopLoader();
				});
			}).catch((err) => {
				that.errorMessage("An Error Occured. " + err); that.stopLoader();
			});

		}).catch((err) => {
			that.errorMessage("An Error Occured. " + err); that.stopLoader();
		});
	},
	mixins: [PermissionsMixins],
}


</script>

<style>
h3,
h5 {
	margin: 0px auto;
	padding-bottom: 5px;
}

.input-tel.is-disabled .input-tel__input {
	color: #000 !important;
}

.form-box .el-select {
	width: 100%;
}
</style>